(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CampaignBroadcastController', CampaignBroadcastController)

  CampaignBroadcastController.inject = ['$scope', '$http', 'ngTableParams', 'LangService',  'CampaignBroadcastService', 'NotificationService', 'FoundationApi', 'Upload']

  function CampaignBroadcastController($scope, ngTableParams, $http, LangService,  CampaignBroadcastService, NotificationService, FoundationApi, Upload) {
    var vm = this;

    vm.fileName = null;

    vm.fileColumns = [];

    vm.filter = {
      campaignName: null,
      channelType: null,
      start: null,
      end: null,
      status: null
    }

    vm.getListCampaign = [];

    vm.broadcast = fillBroadcastObject();

    vm.moreInformation = {
      broadcastId: null,
      totalProcessedWithSuccess: 0,
      totalProcessedWithError: 0,
      dueDate: null,
    }

    LangService.getPageLabels({'page': 'menu.campaign.broadcast'}).$promise
      .then(function (data) {
        vm.labelsPage = data.lang;
      });

    index();

    vm.index = () => {
      index();
    }

    vm.openImportModal = () => {
      FoundationApi.publish('importFileModal', 'open');
      getListCampaign();
    }

    vm.closeImportModal = () => {
      vm.fileName = null;
      vm.broadcast = fillBroadcastObject();

      FoundationApi.publish('importFileModal', 'close');
    }

    vm.selectFile = function() {
      document.getElementById('selectedFile').click();
      document.getElementById('selectedFile').onchange = function () {
        vm.fileObject = document.getElementById('selectedFile').files[0];
        vm.fileName = vm.fileObject.name;
      };
    }

    vm.uploadFiles = function () {
      Upload.upload({
        url: frontUrl + '/campaign-broadcast/save',
        file: vm.fileObject,
        fields: clearBroadcastObjectToSend(vm.broadcast)
      }).then(function (response) {
        vm.closeImportModal();
        vm.index();
        NotificationService.successHandler(null, vm.labelsPage.getFileInformationSuccessRequest);
      }, function (response) {
        NotificationService.errorHandler(null, response.data.error);
      });
    }

    vm.downloadFile = function(id) {
      CampaignBroadcastService.downloadFile({'id': id, responseType: 'blob'}).$promise
        .then(function(response) {
          const csvContent = atob(response.data.fileAsBase64);
          var file = new Blob([csvContent], {type: "data:text/csv;charset=utf-8"});

          var url = window.URL || window.webkitURL;

          var downloadLink = angular.element('<a></a>');
          downloadLink.attr('href',url.createObjectURL(file));
          downloadLink.attr('target','_self');
          downloadLink.attr('download', response.data.name);
          downloadLink[0].click();
        })
    }

    vm.openMoreInformationModal = function(id) {
      vm.moreInformation.broadcastId = id;

      this.getMoreInformationOfCampaignBroadCast(vm.moreInformation.broadcastId);
      FoundationApi.publish('importMoreInformationModal', 'open');
    }

    vm.closeMoreInformationModal = function() {
      FoundationApi.publish('importMoreInformationModal', 'close');
    }

    vm.getMoreInformationOfCampaignBroadCast = function(id) {
      return CampaignBroadcastService.getMoreInformation({'id': id}).$promise.then(function (response) {
        if (response.data) {
          vm.moreInformation.totalProcessedWithSuccess = response.data.totalProcessedWithSuccess;
          vm.moreInformation.totalProcessedWithError = response.data.totalProcessedWithError;
          vm.moreInformation.dueDate = response.data.dueDate;
        }
      });
    }

    window.dropFile = function(e) {
      e.preventDefault();
      vm.fileObject = e.dataTransfer.files[0];
      vm.fileName = vm.fileObject.name;
    }

    function index() {
      var start;
      var end;

      if (vm.filter.start) {
        start = moment(vm.filter.start, "DD/MM/YYYY").format("YYYY-MM-DD");
      }
      if (vm.filter.end) {
        end = moment(vm.filter.end, "DD/MM/YYYY").format("YYYY-MM-DD");
      }

      vm.indexList = new ngTableParams({
        page: 1,
        count: 10
      }, {
        getData: function ($defer, params) {
          CampaignBroadcastService
            .index({
              campaignName: vm.filter.campaignName,
              channelType: vm.filter.channelType,
              start: start,
              end: end,
              status: vm.filter.status,
              page: params.page()
            })
            .$promise
            .then(function (data) {
              $defer.resolve(data.pagination.data)
              params.total(data.pagination.total);
              vm.total = (data.pagination.total);
              vm.campaignChannelTypeList = angular.copy(data.campaignChannelTypeList);
              vm.campaignBroadcastStatusList = angular.copy(data.campaignBroadcastStatusList);
            }).catch(function (data) {
            NotificationService.errorHandler(data, data.data.error);
          });
        }
      })
    }

    function getListCampaign() {
      CampaignBroadcastService.getList().$promise
        .then(function (response) {
          if (response.data) {
            vm.getListCampaign = response.data;
          }
        });
    }

    function getDefaultDueDate() {
      var startDate = new Date();
      const NUMBER_OF_DAYS_TO_EXPIRATION = 2;

      return new Date(startDate.setDate(startDate.getDate()+NUMBER_OF_DAYS_TO_EXPIRATION));
    }

    function fillBroadcastObject() {
      return {
        dueDate: getDefaultDueDate(),
        campaignId: null
      };
    }

    function clearBroadcastObjectToSend(broadcastObject) {
      for (const prop in broadcastObject) {
        if (broadcastObject[prop] == null) {
          delete broadcastObject[prop];
        }
      }
      return broadcastObject;
    }
  }
})();
